import { render, staticRenderFns } from "./ChatAi.vue?vue&type=template&id=2feda1bb&scoped=true&"
import script from "./ChatAi.vue?vue&type=script&lang=js&"
export * from "./ChatAi.vue?vue&type=script&lang=js&"
import style0 from "./ChatAi.vue?vue&type=style&index=0&id=2feda1bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feda1bb",
  null
  
)

export default component.exports